<div class="header_div" *ngIf="headerShow">
  <div class="header">
    <a href="{{commonService.commonMainObj.stagingPortalUrl}}" class="logo header_a"> <img alt="Sierra Circuits" style="width: 90%;" src="https://www.protoexpress.com/wp-content/uploads/2021/04/logo.svg"/></a>
    <a class="header_a2 fs12 mt-1">Best-in-Class PCB Fabrication, Assembly & Components.
      Industry Leading PCB Designer's Tools.</a>
    <div class="header-right">
      <div class="fs14 get-assist text-center"><img alt="suppost" src="../assets/img/calling.png" width="15"> Get Assistance:  <a href="tel:+1 (650) 750-8883" class="tel_phone_number p-0">+1 (650) 750-8883</a> <br> Monday to Friday, 9am to 5pm PST</div>
      <!-- <div *ngIf="commonService.commonMainObj.userData.firstName"></div> -->
      <div class="text-center fs14" style="margin: -18px;margin-left: 20px;" *ngIf="commonService.commonMainObj.userData.firstName">
        <div>{{commonService.commonMainObj.userData.firstName}} {{commonService.commonMainObj.userData.lastName}}</div>
        <div>{{commonService.commonMainObj.userData.registrationEmail}}</div>
        <!--  (click)="logout()" -->
        <button type="button" class="btn btn-small btn-warning py-xl-0" data-mdb-toggle="button" autocomplete="off" aria-pressed="true"> <b><a class="text-decoration-none black-txt" title="Sign In" href="{{commonService.commonMainObj.stagingPortalUrl}}/customer-portal/logout/ ">Logout</a></b>
        </button>
      </div>
    </div>
  </div>
</div>
<input type="file" name="customFileUpload" accept=".zip,.tar,.tgz" class="form-control" id="customFileUpload2" style="visibility:hidden;height: 0;width: 0;position: fixed;" (change)="commonService.uploadFiles($event)" *ngIf="headerShow"/>

<div id="iframeContainer" class="iframe-container" style="height: 1px;width: 1px;visibility: hidden;">
  <iframe id="dynamicIframe" src="" title="Dynamic Iframe"></iframe>
</div>
<router-outlet></router-outlet>